import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType} from "vue";
import {VASwitchOptions} from "./typings";


export default /*@__PURE__*/_defineComponent({
  __name: 'VASwitch',
  props: {
  value: {
    type: Object as PropType<string| number | boolean>,
    required: true
  },
  options: {
    type: Object as PropType<VASwitchOptions>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size:{
    type: String,
  }
},
  emits: ['on-change', "update:value"],
  setup(__props, { emit: __emit }) {


const emits = __emit



const change = (value: string| number | boolean) => {
  emits("update:value", value)
  emits('on-change', value)
}


return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createBlock(_component_a_switch, {
    checked: __props.value,
    checkedValue: __props.options.checked.value,
    unCheckedValue: __props.options.unChecked.value,
    checkedChildren: __props.options.checked.label,
    disabled: __props.disabled,
    size: __props.size,
    unCheckedChildren: __props.options.unChecked.label,
    onChange: change
  }, null, 8, ["checked", "checkedValue", "unCheckedValue", "checkedChildren", "disabled", "size", "unCheckedChildren"]))
}
}

})